import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import '../../../../cssfiles/homepage.css';
import { Typography } from '@mui/material';
import '../../../../cssfiles/homepage.css';
import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector, useDispatch } from "react-redux";

export default function Gauge(props){

    //console.log("Gauge props",props)
    const theme = useSelector((state) => state.themedata.theme)
    const newdata = useSelector((state) => state.mainpagedata.updateddashboarddata)

    const [value, setValue] = useState(0)
    const [targetvalue, setTargetvalue] = useState(0)   // if we keep target 8000 marker comes at end of 8000, hence we need to keep marker at 8000-6700:target - current in case target>current
                                                              //target== current keep marker at current/target
                                                              //current>target
    const [valuep, setValuep] = useState(0.3)
    const [targetp, setTargetp] = useState(1)
    //total consumption-10,000
    //target consumption-8000
    //consumed-6700

    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues)
    //console.log("Gauge inside mixed chart**********************tagcollectionvalue********************",tagcollectionvalue)
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)


    const [value1, setValue1] = useState(0)
    const [value2, setValue2] = useState(0)
    const [value3, setValue3] = useState(0)
    const [color1, setColor1] = useState(0)
    const [color2, setColor2] = useState(0)
    const [color3, setColor3] = useState(0)
    const [gaugedataoption,setGaugedataoption] = useState({})
   // const[option,setOption]= useState(gaugedataoption); 

    useEffect(()=>{
      var series_consumed = {};
      var switch_on_total = 0;
      var switch_on_target = 0;
      var switch_on_actual = 0;

      var switch_off_total = 0;
      var switch_off_target = 0;
      var switch_off_actual = 0;

      var switch_on_actual_percentage = 0;
      var switch_on_target_percentage = 0;
      var switch_off_actual_percentage = 0;
      var switch_off_target_percentage = 0;

      var tag_properties = props.widgetprop.props.extended.tagprops;
      //console.log("gauge -tag_properties",tag_properties)
        tag_properties.map((charttype)=>{
          var data=[];
          if(tagcollectionvalue.hasOwnProperty(charttype.tagid)){
            //console.log("tagcollectionvalue[charttype.tagid]",tagcollectionvalue[charttype.tagid])
            tagcollectionvalue[charttype.tagid].map((tagvalue)=>{
              data.push(tagvalue.y)
            })
            if(charttype.gauge_label=='value' && charttype.switch_position=='on'){
                switch_on_actual=data.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue), 0.0)
            }else if(charttype.gauge_label=='value' && charttype.switch_position=='off'){
                switch_off_actual=data.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue), 0.0)
            }else if(charttype.gauge_label=='target' && charttype.switch_position=='on'){
                switch_on_target=data.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue), 0.0)
            }else if(charttype.gauge_label=='target' && charttype.switch_position=='off'){
                switch_off_target=data.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue), 0.0)
            }else if(charttype.gauge_label=='total' && charttype.switch_position=='on'){
                switch_on_total=data.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue), 0.0)
            }else if(charttype.gauge_label=='total' && charttype.switch_position=='off'){
                switch_off_total=data.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue), 0.0)
            } 

          }
          
        })

        //console.log("switch_on_actual",switch_on_actual)
        //console.log("switch_on_target",switch_on_target)
       // console.log("switch_on_total",switch_on_actual)
        //console.log("switch_off_actual",switch_off_actual)
        //console.log("switch_off_target",switch_off_target)
        //console.log("switch_off_total",switch_off_actual)

        switch_on_actual_percentage = parseFloat(switch_on_actual/switch_on_total)
        switch_on_target_percentage = parseFloat(switch_on_target/switch_on_total)
        switch_off_actual_percentage = parseFloat(switch_off_actual/switch_off_total)
        switch_off_target_percentage = parseFloat(switch_off_target/switch_off_total)

        series_consumed =(props.energycostbudget==true) ? 
           
          { //series[0].data[0].value-series[1].data[0].value
          series: [
            {
              type: 'gauge',
              detail: { show: false }, // Hide the detail text
              data:[{ value:switch_on_actual, name: 'kWh' }], // Unit hardcoded
              min: 0,
              max: switch_on_total,
              itemStyle:{
                  border:'5px solid #FFFFFF',
                  color:'#FFFFFF',
              },
              axisLine: {
                lineStyle: {
                  width: 18, // Adjust the thickness of the gauge ring-
                  color:(switch_on_target_percentage >= switch_on_actual_percentage) ?
                        [[switch_on_actual_percentage, '#0076F6'],[switch_on_target_percentage, '#C1C1C1'], [1, '#C1C1C1']]:
                        [[switch_on_target_percentage, '#0076F6'],[switch_on_actual_percentage, '#DC272D'], [1, '#C1C1C1']], // Configure color stops for the gauge ring    /* 3200 to 0.4 calculation needs to be done*/
                },
              },
              axisLabel: {
                show: false, // Hide axis labels
              },
              axisTick: {
                show: false, // Hide axis ticks
              },
              splitLine: {
                show: false, // Hide split lines
              },
              pointer: {
                show:false,
                icon:'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
                length: '20%', // Length of the pointer
                width: 8, // Width of the pointer
                itemStyle: {
                  color: '#DC272D', // Color of the pointer
                  borderRadius:8
                },
                offsetCenter: [0, '-85%'],
              },
              title: {
                show: true, // Show the title
                offsetCenter: [0, '-3%'], // Adjust the position of the title
                textStyle: {
                  color: theme == 'dark'?'#FFFFFF':'#000000', // Color of the title text
                  fontSize: "28px", // Font size of the title text
                  fontWeight: 700, // Font weight of the title text
                },
                text: 'Your Text Here', // Text to display in the dial area
                
              }
              ,detail:{
                offsetCenter:['0%','-25%'],
                color:theme == 'dark'?'#FFFFFF':'#000000',
                formatter: function (value) {
                  return value.toFixed(2);
                },
                rich: {
                  value: {
                    fontSize: "25px",
                    fontWeight:  400,
                    color: '#FFFFFF',
                    padding: [0, 0, -20, 10]
                  },
                  unit: {
                    fontSize: 18,
                    color: '#FFFFFF',
                    padding: [0, 0, -20, 10]
                  }
                }
              },
              center: ['50%', '50%'], // Center of the gauge
              radius: '90%', // Size of the gauge
              startAngle: 180, // Start angle of the gauge
              endAngle: 0, // End angle of the gauge
            },
            {
              type: 'gauge',
              detail: { show: false},
              min: 0,
              max: switch_on_total,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false, // Hide axis ticks
              },
              axisLabel: {
                show: false, // Hide axis ticks
              },
              splitLine: {
                show: false, // Hide split lines
              },
              pointer: {
                show:true,
                icon:'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
                length: '20%', // Length of the pointer
                width: 4, // Width of the pointer
                itemStyle: {
                  color: '#DC272D', // Color of the pointer
                  borderRadius:8
                },
                offsetCenter: [0, '-95%'],
              },
              itemStyle: {
                color: 'rgba(255, 255, 255, 0)', // Set color of the extended track
              },
              data: [{ 
                      
                      value: switch_on_target,  //0.67+0.35
                      name: '',
                      show:true,
                      title: {
                        show: true,
                        offsetCenter: [0, '-50%'], // Adjust the offset to move the title above the needle
                        z: 1000// Set the z-level to a higher value to ensure it appears above the needle
                      },
                   }],
              radius: '80%', // Size of the gauge
              center: ['50%', '50%'], // Center of the gauge
              startAngle: 180, // Start angle of the gauge
              endAngle: 0, // End angle of the gauge
            },
          ],
          tooltip: {
            backgroundColor: '#005C8E', // Transparent black background
            borderColor: '#005C8E',
            extraCssText: 'border-radius: 0 0 0 8px',
            valueFormatter: (value) => Number(value).toFixed(2),
            textStyle:{
              color:"#fff",
              fontSize: 12,
              height: 3,
              fontFamily: "Roboto",
              padding: 0
            }
          }
          }
          :
          { //series[0].data[0].value-series[1].data[0].value
          series: [
            {
              type: 'gauge',
              detail: { show: false }, // Hide the detail text
              data:[{ value: switch_off_actual, name: 'INR' }], // Unit hardcoded
              min: 0,
              max: switch_off_total,
              itemStyle:{
                  border:'5px solid #FFFFFF',
                  color:'#FFFFFF',
              },
              axisLine: {
                lineStyle: {
                  width: 18, // Adjust the thickness of the gauge ring-
                  color: (switch_off_target_percentage >= switch_off_actual_percentage) ?
                  [[switch_off_actual_percentage, '#0076F6'],[switch_off_target_percentage, '#C1C1C1'], [1, '#C1C1C1']]:
                  [[switch_off_target_percentage, '#0076F6'],[switch_off_actual_percentage, '#DC272D'], [1, '#C1C1C1']], // Configure color stops for the gauge ring    /* 3200 to 0.4 calculation needs to be done*/
                },
              },
              axisLabel: {
                show: false, // Hide axis labels
              },
              axisTick: {
                show: false, // Hide axis ticks
              },
              splitLine: {
                show: false, // Hide split lines
              },
              pointer: {
                show:false,
                icon:'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
                length: '20%', // Length of the pointer
                width: 8, // Width of the pointer
                itemStyle: {
                  color: '#DC272D', // Color of the pointer
                  borderRadius:8
                },
                offsetCenter: [0, '-85%'],
              },
              title: {
                show: true, // Show the title
                offsetCenter: [0, '-3%'], // Adjust the position of the title
                textStyle: {
                  color: theme == 'dark'?'#FFFFFF':'#000000', // Color of the title text
                  fontSize: "28px", // Font size of the title text
                  fontWeight: 700, // Font weight of the title text
                },
                text: 'Your Text Here', // Text to display in the dial area
                
              }
              ,detail:{
                offsetCenter:['0%','-25%'],
                color:theme == 'dark'?'#FFFFFF':'#000000',
                formatter: function (value) {
                  return value.toFixed(2);
                },
                rich: {
                  value: {
                    fontSize: "25px",
                    fontWeight:  400,
                    color: '#FFFFFF',
                    padding: [0, 0, -20, 10]
                  },
                  unit: {
                    fontSize: 18,
                    color: '#FFFFFF',
                    padding: [0, 0, -20, 10]
                  }
                }
              },
              center: ['50%', '50%'], // Center of the gauge
              radius: '90%', // Size of the gauge
              startAngle: 180, // Start angle of the gauge
              endAngle: 0, // End angle of the gauge
            },
            {
              type: 'gauge',
              detail: { show: false},
              min: 0,
              max: switch_off_total,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false, // Hide axis ticks
              },
              axisLabel: {
                show: false, // Hide axis ticks
              },
              splitLine: {
                show: false, // Hide split lines
              },
              pointer: {
                show:true,
                icon:'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
                length: '20%', // Length of the pointer
                width: 4, // Width of the pointer
                itemStyle: {
                  color: '#DC272D', // Color of the pointer
                  borderRadius:8
                },
                offsetCenter: [0, '-95%'],
              },
              itemStyle: {
                color: 'rgba(255, 255, 255, 0)', // Set color of the extended track
              },
              data: [{ 
                      
                      value: switch_off_target,  //0.67+0.35
                      name: '',
                      show:true,
                      title: {
                        show: true,
                        offsetCenter: [0, '-50%'], // Adjust the offset to move the title above the needle
                        z: 1000// Set the z-level to a higher value to ensure it appears above the needle
                      },
                   }],
              radius: '80%', // Size of the gauge
              center: ['50%', '50%'], // Center of the gauge
              startAngle: 180, // Start angle of the gauge
              endAngle: 0, // End angle of the gauge
            },
          ],
          tooltip: {
            backgroundColor: '#005C8E', // Transparent black background
            borderColor: '#005C8E',
            extraCssText: 'border-radius: 0 0 0 8px',
            valueFormatter: (value) => Number(value).toFixed(2),
            textStyle:{
              color:"#fff",
              fontSize: 12,
              height: 3,
              fontFamily: "Roboto",
              padding: 0
            }
          
            }
          }

        //console.log(se)  
        setGaugedataoption(series_consumed)
          //setSeriesChart(series_consumed);
        if(props.energycostbudget==true){
           
            props.setPercentageConsumed(Number(switch_on_actual_percentage * 100).toFixed(2));
            props.setTargetValue(Number(switch_on_target).toFixed(2));
            props.setTotalValue(Number(switch_on_total).toFixed(2));
            if(switch_on_target_percentage >= switch_on_actual_percentage){
                props.setExceed(false);
            }else{
                props.setExceed(true);
            }  
        }else{
            props.setPercentageConsumed(Number(switch_off_actual_percentage * 100).toFixed(2));
            props.setTargetValue(Number(switch_off_target).toFixed(2));
            props.setTotalValue(Number(switch_off_total).toFixed(2));
            if(switch_off_target_percentage >= switch_off_actual_percentage){ 
                props.setExceed(false);
            }else{
                props.setExceed(true);
            }
        }


  },[props.widgetprop,tagcollectionvalue,props.energycostbudget,props.setPercentageConsumed,theme])

/*    useEffect(()=>{
        calculatetotal();

        if(props.energycostbudget == true){
            setTargetvalue(switch_on_target);
            setValue(switch_on_actual);
            props.setPercentageConsumed("Target = "+switch_on_target)
            if(switch_on_actual_percentage <= switch_on_target_percentage){
                setValue1(switch_on_actual_percentage);
                setValue2(switch_on_target_percentage);
                setValue3(1);
                setColor1('#0076F6');
                setColor2((theme=='light')?'#C1C1C1':'#3C3C3C');
                setColor3((theme=='light')?'#C1C1C1':'#3C3C3C');
            }else if(switch_on_actual_percentage > switch_on_target_percentage){
                setValue1(switch_on_target_percentage);
                setValue2(switch_on_actual_percentage);
                setValue3(1);
                setColor1('#0076F6');
                setColor2('#DC272D');
                setColor3((theme=='light')?'#C1C1C1':'#3C3C3C');
          }
        }else if(props.energycostbudget == false){
            setTargetvalue(switch_off_target);
            setValue(switch_off_actual);
            props.setPercentageConsumed("Target = "+ switch_off_target)
            if(switch_off_actual_percentage <= switch_off_target_percentage){
                setValue1(switch_off_actual_percentage);
                setValue2(switch_off_target_percentage);
                setValue3(1);
                setColor1('#0076F6');
                setColor2((theme=='light')?'#C1C1C1':'#3C3C3C');
                setColor3((theme=='light')?'#C1C1C1':'#3C3C3C');
            }else if(switch_off_actual_percentage > switch_off_target_percentage){
                setValue1(switch_off_target_percentage);
                setValue2(switch_off_actual_percentage);
                setValue3(1);
                setColor1('#0076F6');
                setColor2('#DC272D');
                setColor3((theme=='light')?'#C1C1C1':'#3C3C3C');
          }
        }
      
    },[props.energycostbudget,tagcollectionvalue,sdate_edate_selected])
*/

    const gaugeData = [
        {
          value: value, // Adjust this value to set the percentage of the top semicircular part to be filled
          title: {
            show:true,
            text:'We are on Target',
            offsetCenter: ['0%', '-10%']
          },
          detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '-10%'],
              fontSize: props.widgetprop.props.extended.gauge_properties.gaugetext.fontsize,
              fontWeight:props.widgetprop.props.extended.gauge_properties.gaugetext.fontweight,
              borderWidth: 0,
              formatter: value+'kWh'
          }
        }
    ];   
    var gaugeoption1 = { //series[0].data[0].value-series[1].data[0].value
      series: [
        {
          type: 'gauge',
          detail: { show: false }, // Hide the detail text
          data: (props.energycostbudget== true)?[{ value: value, name: 'kWh' }]:[{ value: value, name: 'INR' }], // Initial value and name for the gauge
          min: 0,
          max: 10000,
          itemStyle:{
              border:'5px solid #FFFFFF',
              color:'#FFFFFF',
          },
          axisLine: {
            lineStyle: {
              width: 18, // Adjust the thickness of the gauge ring-
              color: [[value1, color1],[value2, color2], [value3, color3]], // Configure color stops for the gauge ring    /* 3200 to 0.4 calculation needs to be done*/
            },
          },
          axisLabel: {
            show: false, // Hide axis labels
          },
          axisTick: {
            show: false, // Hide axis ticks
          },
          splitLine: {
            show: false, // Hide split lines
          },
          pointer: {
            show:false,
            icon:'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
            length: '20%', // Length of the pointer
            width: 8, // Width of the pointer
            itemStyle: {
              color: '#DC272D', // Color of the pointer
              borderRadius:8
            },
            offsetCenter: [0, '-85%'],
          },
          title: {
            show: true, // Show the title
            offsetCenter: [0, '-3%'], // Adjust the position of the title
            textStyle: {
              color: theme == 'dark'?'#FFFFFF':'#000000', // Color of the title text
              fontSize: "28px", // Font size of the title text
              fontWeight: 700, // Font weight of the title text
            },
            text: 'Your Text Here', // Text to display in the dial area
            
          }
          ,detail:{
            offsetCenter:['0%','-25%'],
            color:theme == 'dark'?'#FFFFFF':'#000000',
            formatter: function (value) {
              return value.toFixed(2);
            },
            rich: {
              value: {
                fontSize: "25px",
                fontWeight:  400,
                color: '#FFFFFF',
                padding: [0, 0, -20, 10]
              },
              unit: {
                fontSize: 18,
                color: '#FFFFFF',
                padding: [0, 0, -20, 10]
              }
            }
          },
          center: ['50%', '50%'], // Center of the gauge
          radius: '90%', // Size of the gauge
          startAngle: 180, // Start angle of the gauge
          endAngle: 0, // End angle of the gauge
        },
        {
          type: 'gauge',
          detail: { show: false},
          min: 0,
          max: 10000,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false, // Hide axis ticks
          },
          axisLabel: {
            show: false, // Hide axis ticks
          },
          splitLine: {
            show: false, // Hide split lines
          },
          pointer: {
            show:true,
            icon:'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
            length: '20%', // Length of the pointer
            width: 4, // Width of the pointer
            itemStyle: {
              color: '#DC272D', // Color of the pointer
              borderRadius:8
            },
            offsetCenter: [0, '-95%'],
          },
          itemStyle: {
            color: 'rgba(255, 255, 255, 0)', // Set color of the extended track
          },
          data: [{ 
                  
                  value: targetvalue,  //0.67+0.35
                  name: '',
                  show:true,
                  title: {
                    show: true,
                    offsetCenter: [0, '-50%'], // Adjust the offset to move the title above the needle
                    z: 1000// Set the z-level to a higher value to ensure it appears above the needle
                  },
               }],
          radius: '80%', // Size of the gauge
          center: ['50%', '50%'], // Center of the gauge
          startAngle: 180, // Start angle of the gauge
          endAngle: 0, // End angle of the gauge
        },
      ],
      tooltip: {
        backgroundColor: '#005C8E', // Transparent black background
        borderColor: '#000000',}
    };
    
    /*
    if(gaugedataoption.series[0].data[0].value-gaugedataoption.series[1].data[0].value > 0 ){
     
        props.setExceed(true)
    }else{
      
        props.setExceed(false)
    }*/

  /*  
    useEffect(() => {
        if(props.widgetprop.widgetname=="Energy Budgeting (INR) & Consumption(kWh)"){
            setOption(gaugedataoption)
        }
    },[props.widgetprop,tagcollectionvalue,props.energycostbudget]);
*/
    return ( 
      <> 
        {/*console.log("Gauge options",gaugedataoption)*/}
        <div>
            <ReactECharts option={gaugedataoption} style={{ height: '300px', marginTop:"0px" }}/>
        </div>
      </>
    );
}